module.exports = __webpack_public_path__ + "static/img/wealth_level_72.4e831b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_72.png
// module id = 69PW
// module chunks = 0